export default __webpack_public_path__ + "static/media/project2.34ebd7a7.png";